import { useRouter } from 'next/router'

import ArticleAuthor from '~/shared/components/Articles/ArticleAuthor/ArticleAuthor'
import { Link } from '~/components'
import { SanityImage } from '~/types/sanity'

import styles from '~/shared/components/Articles/Articles.module.css'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '128px' }]

export default function VerticalArticleItem({
  author,
  authorAvatar,
  className = '',
  ingress,
  quadraticImage,
  slug,
  title,
  releaseDate,
}: {
  author?: string
  authorAvatar?: SanityImage
  className?: string
  content: unknown[]
  ingress?: string
  quadraticImage: SanityImage
  slug: string
  title: string
  releaseDate: string
}): React.ReactElement {
  const { pathname } = useRouter()

  return (
    <Link className={`w-full ${className}`} to={`${pathname}/${slug}`}>
      <article className="flex flex-col">
        <div className="flex justify-between items-center mb-2">
          <ArticleAuthor author={author} authorAvatar={authorAvatar} className="mr-2" releaseDate={releaseDate} />
        </div>
        <div className="flex items-start">
          <div className="flex-1">
            <header className="mt-2">
              <h2 className="mb-1 text-md md:text-lg font-semibold">{title}</h2>
            </header>
            <div className={`${styles.ingress} ${styles['clamp-2']} leading-7`}>{ingress}</div>
          </div>
          <div className="shrink-0 ml-4">
            <ResponsiveImage
              alt={quadraticImage.alt}
              height={128}
              imageClassName="rounded"
              imageWidths="128"
              mediaQuery={mediaQuery}
              srcKey={quadraticImage.srcKey ?? ''}
              width={128}
            />
          </div>
        </div>
      </article>
    </Link>
  )
}
